/**
 * Procurement permission keys (catalog `proc.*`, docs/contracts/procurement.md §8). The UI hides what a key does not
 * allow; the API checks the same keys, the department data scope of the requests (P7) and the four-eyes rule of the
 * approvals (G3, SP17).
 */
export const procPermissions = {
  moduleView: "proc.procurment.view",
  requestView: "proc.request.view",
  requestCreate: "proc.request.create",
  requestUpdate: "proc.request.update",
  requestDelete: "proc.request.delete",
  requestPrint: "proc.request.print",
  requestHistory: "proc.request.history",
  requestApprove: "proc.request.approve",
  requestCancel: "proc.request.cancel",
  requestClose: "proc.request.close",
  requestConvert: "proc.request.convert",
  tenderView: "proc.tender.view",
  tenderCreate: "proc.tender.create",
  tenderUpdate: "proc.tender.update",
  tenderPublish: "proc.tender.post",
  tenderDelete: "proc.tender.delete",
  tenderPrint: "proc.tender.print",
  tenderHistory: "proc.tender.history",
  tenderOpen: "proc.tender.open",
  tenderEvaluate: "proc.tender.evaluate",
  tenderAward: "proc.tender.award",
  tenderApprove: "proc.tender.approve",
  tenderCancel: "proc.tender.cancel",
  refillView: "proc.refill_request.view",
  refillCreate: "proc.refill_request.create",
  refillUpdate: "proc.refill_request.update",
  refillFulfil: "proc.refill_request.post",
  refillDelete: "proc.refill_request.delete",
  refillPrint: "proc.refill_request.print",
  refillHistory: "proc.refill_request.history",
  refillApprove: "proc.refill_request.approve",
  refillCancel: "proc.refill_request.cancel",
  serviceView: "proc.service.view",
  serviceCreate: "proc.service.create",
  serviceUpdate: "proc.service.update",
  serviceDelete: "proc.service.delete",
  budgetView: "proc.budget.view",
  budgetUpdate: "proc.budget.update",
  settingsView: "proc.settings.view",
  settingsUpdate: "proc.settings.update",
} as const;

/** Plan module of Procurement (P6). */
export const procModule = "procurement";

/** The procurement settings group (`/platform/settings/proc`). */
export const procSettingsGroup = "proc";
